import React from "react";
import { Container, Card } from "react-bootstrap";

const sections = [
  {
    heading: "Introduction",
    body: [
      'These Terms of Service ("Terms") govern your use of the Rentalo platform, including our website, mobile applications, APIs, and any related services (collectively, the "Services"). By accessing or using the Services, you agree to be bound by these Terms.',
      "If you do not agree with these Terms, you must stop using the Services immediately.",
    ],
  },
  {
    heading: "Eligibility",
    body: [
      "You must be at least 18 years old and capable of forming a binding contract in order to use the Services. By registering an account, you represent and warrant that you meet these eligibility requirements.",
      "We may suspend or terminate your access to the Services at any time if we believe you do not meet the eligibility criteria or have otherwise violated these Terms.",
    ],
  },
  {
    heading: "User Accounts",
    body: [
      "To access certain features of the Services, you must create an account and provide accurate, current, and complete information as requested. You are responsible for maintaining the confidentiality of your credentials and for all activities that occur under your account.",
      "You agree to notify us immediately of any unauthorized use of your account or breach of security. Rentalo will not be liable for any loss or damage arising from your failure to keep your account secure.",
    ],
  },
  {
    heading: "Listings and Transactions",
    body: [
      "Rentalo connects property owners, service providers, buyers, renters, and job seekers with interested parties. We are not a party to any agreements between users. You are solely responsible for the accuracy of your listings, the services you provide, and the transactions you enter into.",
      "You must comply with all applicable laws, regulations, and industry standards when posting listings, providing services, or completing transactions through the Services.",
    ],
  },
  {
    heading: "Payments and Fees",
    body: [
      "Certain features may require payment of fees or subscriptions, such as our Prime membership benefits. By purchasing any paid Services, you authorize Rentalo and our payment processors to charge the specified amounts to your selected payment method.",
      "All fees are non-refundable except where required by law. You are responsible for any taxes associated with your transactions on the platform.",
    ],
  },
  {
    heading: "Prime Membership",
    body: [
      "Prime membership benefits, including promotional placement and badges, are provided on a best-effort basis and may be modified or discontinued at any time. We may revoke Prime status if we suspect abuse, fraudulent activity, or violation of these Terms.",
      "Prime membership is personal to the account holder and may not be transferred or shared without our prior written consent.",
    ],
  },
  {
    heading: "User Content",
    body: [
      "You retain ownership of the content you submit, post, or display through the Services. By providing content, you grant Rentalo a non-exclusive, worldwide, royalty-free license to use, reproduce, modify, publish, and display the content solely for the purpose of operating and improving the Services.",
      "You represent and warrant that you have all necessary rights to grant this license and that your content does not violate any third-party rights or applicable law.",
    ],
  },
  {
    heading: "Acceptable Use",
    body: [
      "You agree not to misuse the Services, including but not limited to engaging in fraudulent activity, posting misleading or discriminatory content, interfering with other users, or attempting to gain unauthorized access to our systems.",
      "We reserve the right to remove content or suspend accounts that violate our policies or these Terms without prior notice.",
    ],
  },
  {
    heading: "Disclaimers",
    body: [
      'The Services are provided on an "as is" and "as available" basis. Rentalo makes no warranties or representations, express or implied, regarding the accuracy, reliability, or completeness of the Services.',
      "We do not guarantee the quality, safety, or legality of listings, services, or interactions between users. You engage with other users at your own risk.",
    ],
  },
  {
    heading: "Limitation of Liability",
    body: [
      "To the maximum extent permitted by law, Rentalo, its affiliates, directors, employees, and agents shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of the Services.",
      "Our total liability for any claim arising from these Terms or the Services shall not exceed the amount paid by you to Rentalo in the twelve (12) months preceding the event giving rise to the claim.",
    ],
  },
  {
    heading: "Indemnification",
    body: [
      "You agree to indemnify, defend, and hold harmless Rentalo and its affiliates from any claims, liabilities, damages, losses, and expenses (including reasonable attorneys' fees) arising out of or related to your use of the Services, your content, or your violation of these Terms.",
    ],
  },
  {
    heading: "Termination",
    body: [
      "We may suspend or terminate your access to the Services at any time for any reason, including if we believe that you have violated these Terms or engaged in fraudulent or harmful behavior.",
      "Upon termination, you must cease all use of the Services and any provisions of these Terms intended to survive termination will remain in effect.",
    ],
  },
  {
    heading: "Changes to These Terms",
    body: [
      'We may modify these Terms from time to time. When we make changes, we will update the "Last updated" date at the top of this page. Your continued use of the Services after the effective date of any changes constitutes your acceptance of the revised Terms.',
    ],
  },
  {
    heading: "Governing Law",
    body: [
      "These Terms are governed by and construed in accordance with the laws of India, without regard to its conflict of laws principles.",
      "Any disputes arising under or relating to these Terms shall be subject to the exclusive jurisdiction of the courts located in Bengaluru, Karnataka, India.",
    ],
  },
  {
    heading: "Contact Us",
    body: [
      "If you have questions about these Terms, please contact us at support@rentalo.in or write to Rentalo, Bengaluru, Karnataka, India.",
    ],
  },
];

export default function Terms() {
  return (
    <Container className="py-4">
      <Card className="shadow-sm border-0 rounded-4">
        <Card.Body>
          <h2 className="fw-bold text-gradient mb-3">Terms of Service</h2>
          <p className="text-muted mb-4">Last updated: November 21, 2025</p>
          <div className="d-flex flex-column gap-4">
            {sections.map((section) => (
              <section key={section.heading}>
                <h5 className="fw-semibold mb-2">{section.heading}</h5>
                {section.body.map((paragraph, index) => (
                  <p key={index} className="text-secondary mb-2">
                    {paragraph}
                  </p>
                ))}
              </section>
            ))}
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}
